import React, { Component, PropType } from 'react'
import GroupRowInnerRenderer from './groupRowInnerRenderer.js'

var drillObj = null;
var associateColumnData = [];
var downloadStyle = {
    cursor: 'pointer',
    width: '40px',
    marginTop: '6px'
}
var is_header_size_increase=false;
var sort = [];
var transposeGlobal = false;
var metricObjectGlobal = [];

class TableDownload extends React.Component{
    constructor(props) {
        super(props);
        this.state = props;
    }
    download=(e)=>{
        if (e == "pdf")
            return xepOnline.Formatter.Format(this.state.parentdivID, { render: 'download', srctype: 'svg' });
        if (e == "png")
            return xepOnline.Formatter.Format(this.state.parentdivID, { render: 'newwin', mimeType: 'image/png', resolution: '180', srctype: 'svg' });
    }
    handleChange=(type, e)=>{
        var that = this;
        if (e == null) {
            window.location.href = '/dashboard/report';
        }
    }
    downloadCsv(){
        var url = location.search;
        url = url.replace('property', 'selectedProperty');
        url = url.replace('propertyValues', 'selectedPropertyValue');
        url = url.replace('selectedMetric', 'selectedMetric');
        url = url.replace('breakup', 'breakUp');
        url = url.replace('breakup', 'breakUp');
        window.open("/dashboard/report/gettable" + url+"&download=1");
    }
    render() {
        this.state.parentdivID = 'Parent1';
        var showReport = null;
        var saveReport = null;
        var showChart = null;
        var emptyDiv = null;
        var whiteSpace = null;
        var flag = false;
        var editReport = null;
        if (this.state.report) {
            showReport = <a className="" href='/dashboard/savedreport' target='_blank' id="showReports">Show Reports</a>;
            saveReport = <a data-toggle='modal' href='#saveReportPopup' id='saveReport' className=''>Save Report</a>;
            whiteSpace = <div className='col-md-1'></div>;
            flag = true;
        }
        if (this.state.chartEnable) {
            showChart = <a className="" href='/dashboard/realtime?chartCat=Line' target='_blank' id="showReports">Show Chart</a>;
            whiteSpace = <div className='col-md-2'></div>;
            flag = true;
        }
        if (!flag) {
            emptyDiv = <div className='col-md-4'></div>
        }
        if (window.location.pathname.split('/')[2] == 'savedreport')
            var actionButtonStyle = { marginBottom: '12px' };
        else
            var actionButtonStyle = { marginBottom: '12px' };
        return (
            <div className="col-md-12" style={{padding:"0px"}}>
                <div className="" style={{ position: "relative" }}>
                    <div className='btn-group dropdown pull-right'>
                        <button type="button" className="btn btn-contrast marginStyle fa fa-cloud-download" title='export' id='export' onClick={this.downloadCsv} style={downloadStyle}></button>
                        {/*<button className="btn btn-contrast dropdown-toggle" data-toggle="dropdown" style={actionButtonStyle}>
                            Actions
                            <span className="caret"></span>
                        </button>*/}
                        {/*<ul className="dropdown-menu">
                            <li>{showChart}</li>
                            <li title='Save current view as Report'>{saveReport}</li>
                            <li title='Show saved reports'>{showReport}</li>
                            <li title='Export table content as CSV'><a id="export" href='#' className="">Export</a></li>
                        </ul>*/}
                    </div>
                </div>
            </div>
        );
    }
}

class TableComponent extends React.Component{
    constructor(props) {
        super(props);
        this.state = {...props,messageIndex: 0};
        this.getContextMenuItems = this.getContextMenuItems.bind(this);
        this.drillFunction = this.drillFunction.bind(this);
    }
    componentDidMount() {
        this.createTable(this.state);
        if(this.state.index>1)
            jQuery('#myGridTop'+this.state.index).height(jQuery('#table'+this.state.index).height()-90)

        dragcomplete();
        if (window.location.pathname === '/pinboard') {
            document.body.classList.add('pinboard-active');
        }
    }
    componentDidUpdate() {
        // this.createTable(this.state);
        // if(this.state.index>1)
        //     jQuery('#myGridTop'+this.state.index).height(jQuery('#table'+this.state.index).height()-90)

        dragcomplete();
    }
    componentWillReceiveProps(nextProps) {
        this.createTable(nextProps);
    }

     // Pass dateSelected for table trend
    drillFunction(name, event, value, metric_selected, dateSelected=null, clickedDimension=null, allCurrentValues=null,insightSortOrder=null){
        if(!name)
            name="Blanks";
        var valueDemo = [];
        if (event == 'drillAcross') {
            drillObj.map(function (data) {
                if (value == data.value) {
                    valueDemo.obj = data;
                    valueDemo.value = data.value;
                }
            })
        }
        else if (event == 'drillDown') {
            valueDemo = this.state.drillDown;
        }
        else if (event == 'back') {
            valueDemo = '';
        }
        else if (event == 'insight' || event == 'deepInsight') {
            valueDemo = '';
        }
        else if (event == 'extract') {
            valueDemo = value;
        }
        this.props.drillHandle(name, valueDemo, event, metric_selected, dateSelected, clickedDimension, allCurrentValues, this.props.componentData, insightSortOrder);  // Pass dateSelected for table trend
    }
    getContextMenuItems (params) {
        var result = [];
        var temp = [];
        var temp_raw = [];
        var that = this;
        var allCurrentValues = this.props
        var raw_data_extract = [{"label":"Raw Data","value":"raw"}];
        var property_disp_count = this.props.propertyDisp ? this.props.propertyDisp.length : 0; // Property label count
        var labelClickedInsight = '';
        let isPeriodSet = this.state.period
        // isPeriodSet = isPeriodSet ? (['aggregate', 'Aggregate'].includes(isPeriodSet)) : false
        isPeriodSet = isPeriodSet ? !['aggregate', 'Aggregate'].includes(isPeriodSet) : false;

        // Get the label clicked
        // Case when more than 1 dimension values are selected together
        var labelClicked = params.api.getSelectedNodes().map((innerData)=>{return innerData.data.label}).toString();
        // This is when single value is selected
        labelClicked = labelClickedInsight = labelClicked ? labelClicked : params.node.data.label        
        labelClickedInsight = (`${labelClickedInsight},` + extractLabelValues(params.node.data)).replace(/,$/, '')
        var metric_selected=params.column.colId;

        let insightSortOrder = getInsightSortOrder(params.node.data, metric_selected)
        let clickedColumn = metric_selected
        if (allCurrentValues.kpiMonitoring == 'true' || allCurrentValues.kpiMonitoring == true) {
            allCurrentValues = {...allCurrentValues, 'report': true}
            labelClicked = this.props.data.metric[labelClicked] // labelClicked for kpi monitoring. Make it null
            metric_selected = this.props.shortName[labelClicked][metric_selected] // selected Metric for kpi monitoring
            if (!metric_selected) {
                // get all metadata kpis of the kpi
                // metric_selected = this.props.shortName[labelClicked]['Actual']
                metric_selected = []; 
                let obj = this.props.shortName[labelClicked];
                for (let key in obj) {
                    if (obj.hasOwnProperty(key)) {
                        metric_selected.push(obj[key]);
                    }
                }
                metric_selected.pop()
                metric_selected = metric_selected.join(',');
                allCurrentValues['selectedMetric'] = metric_selected
            }                     
            // If label clicked in not dimension then make it null
            labelClicked = labelClickedInsight = this.props.propertyDisp.length && this.props.propertyDisp['0']['value'] == 'null' || this.props.propertyDisp['0']['label'] == 'all' ? 'Total' : labelClicked
        }        
        var dateSelected = null;
        var clickedDimension = null;    // Will be used in multidim case to take the dimension when 1 of value is clicked among many dimension.
        if(metric_selected.split(';')[1]!==undefined) {
            var metric_selected_split = metric_selected.split(';');
            let metric_selected_split_length = metric_selected_split.length-1
            /* Commented below if-condition - to select only first point as include in case of two dimensions in crosstab */
            // if(property_disp_count == 2) {  // If Property label count is two i.e, cross tab then 2 points will come. Get the second point
            //     labelClickedInsight += ',' + metric_selected_split[2];     // Get the property value clicked
            // } else
            let indexToSubtract = 0
            if(isPeriodSet) {
                dateSelected = metric_selected_split[metric_selected_split_length];            
                indexToSubtract = 1
            }
            labelClickedInsight = this.props.propertyDisp.length > 1 ? (this.props.propertyDisp[1]['value'].split(';')[1] ? labelClickedInsight : `${labelClickedInsight},${metric_selected_split[metric_selected_split_length-indexToSubtract]}`) : labelClickedInsight
                        
            metric_selected = metric_selected_split[0] + ";" + metric_selected_split[1];    // Metric selected
        }
        else {  
            if(transposeGlobal) {   // Case to handle transpose right click                
                metric_selected = metric_selected == 'label' ? labelClicked : metric_selected;  // Case in transport table when click on metric name metric_selected comes as a 'label' and labelClicked comes as a metric name. So replace 'label' with metric name
                let temp = labelClicked;
                labelClicked = metric_selected;
                metric_selected = temp;
                let metricSelectedIndex = arrayColumn(this.props.componentData.selectedMetricDisp,'label').indexOf(metric_selected) 
                metric_selected = metricSelectedIndex!=-1 ? this.props.componentData.selectedMetricDisp[metricSelectedIndex]['value'] : null
                labelClickedInsight = labelClicked;
            } else {
                metric_selected = this.props.selectedMetric;
            }
        }
        // For Multidim
        var clickedKey = null;
        if(property_disp_count>1 && getParameterByName('multiDim', window.location.search) === 'true') {
            var clickedData = params.node.data;
            var i = 0;
            Object.keys(clickedData).forEach(function(key){
                if(key.includes('label')) {
                    if(clickedData[key]==labelClicked) clickedKey = i;                                         
                    i++;
                }                
            });            
            clickedDimension = this.props.propertyDisp[clickedKey].value;
        } else {
            clickedKey = clickedKey ? clickedKey : 0;
            clickedDimension = allCurrentValues.kpiMonitoring == 'true' || allCurrentValues.kpiMonitoring == true ? null : this.props.propertyDisp[clickedKey].value;
        }
        clickedDimension = clickedDimension == 'all' ? null : clickedDimension
        this.state.drillAcross.map(function (innerData, index) {
            temp.push({
                name: innerData.label,
                action: that.drillFunction.bind(this, allCurrentValues.kpiMonitoring == 'true' || allCurrentValues.kpiMonitoring == true ? metric_selected : labelClicked, 'drillAcross', innerData.value, metric_selected, dateSelected, clickedDimension, allCurrentValues)
            })
        })
        raw_data_extract.map(function (innerData, index) {
            temp_raw.push({
                name: innerData.label,
                action: that.rawlogClickHandle.bind(this, labelClicked),
                cssClasses: [`breakdown-${innerData.label}`]
            })
        })        
        if(checkIfFeatureApplicable('Drill Across')) {
            if (history.length) {
                result.push({
                    name: 'Back',
                    action: that.drillFunction.bind(this, labelClicked, 'back', '', metric_selected),
                    cssClasses: ['ag-back']
                })
            }
            if (this.state.drillDown.value) {
                result.push({
                    name: 'Drill Down',
                    action: that.drillFunction.bind(this, labelClicked, 'drillDown', this.state.drillDown, metric_selected, dateSelected, clickedDimension, allCurrentValues),
                    cssClasses: ['ag-drill-down']
                })
            }
            result.push({
                name: 'Breakdown by',
                subMenu: temp,
                cssClasses: ['ag-break-down']
            })
        }        
        if(checkIfFeatureApplicable('Insight')) { //hide auto analysis
            result.push({
                name: 'Auto Analysis',
                action: that.drillFunction.bind(this, labelClickedInsight, 'insight', '', metric_selected, dateSelected, clickedDimension, allCurrentValues, insightSortOrder),
                cssClasses: ['ag-auto-analysis']
            })
        }

        // if(checkIfFeatureApplicable('Root Cause Analysis')) {
        //     result.push({
        //         name: 'Root Cause Analysis',
        //         action: that.drillFunction.bind(this, labelClickedInsight, 'deepInsight', '', metric_selected, dateSelected, clickedDimension, allCurrentValues),
        //         cssClasses: ['ag-auto-analysis']
        //     })
        // }  
        if(clickedColumn != 'label'){

            result.push({
                name: 'View Trend',
                action: that.drillFunction.bind(this, labelClickedInsight, 'chart', '', metric_selected, dateSelected, clickedDimension, allCurrentValues),
                cssClasses: ['ag-trend']
            })
        }      
        // if(extract_data && extract_data!=="0")
        //     result.push({
        //         name: 'Extract',
        //         subMenu: temp_raw,
        //         cssClasses: ['ag-extract']
        //     })
        // else console.log('no ok');
        result.push('copyWithHeaders')
        return result;
    }
    rawlogClickHandle(value){
        jQuery('#download_property').val(value);
        jQuery('#download_handle').modal('toggle')
    }
    createTable(reactObj) {
        var that=this;
        var columnSize = [];
        if(that.props.columnWidth && Object.keys(that.props.columnWidth) > 0){
            Object.entries(that.props.columnWidth).map((item) => {columnSize.push(item)})
        }
        transposeGlobal = that.props.transpose;
        transposeGlobal = transposeGlobal===true || transposeGlobal == 'true' ? true : false;
        let kpiMonitoringFlag = reactObj.kpiMonitoring;
        var propertyDisp = reactObj.propertyDisp;
        var selectedProperty = reactObj.selectedProperty;
        if(allDateColumns) {
            var allDateColumnsArray = allDateColumns.split(',');
            var selectedPropertyArray = selectedProperty ? selectedProperty.split(',') : null;
            if(selectedPropertyArray) {
                var tempCommonElements = _.intersection(allDateColumnsArray, selectedPropertyArray);
                if(tempCommonElements.length) {
                    propertyDisp.map(function(val, index) {
                        tempCommonElements.map(function(val1, index1) {
                            if(val['value'].split(',').indexOf(val1)>-1)
                                dateColumnsToConsider.push(val['label']);
                        });
                    });
                }
            }
        }

        is_header_size_increase=false
        if(reactObj.tablerendered===false){
            return true;
        }
        var divId = '#myGridTop';
        if (reactObj.index) {
            divId += reactObj.index;
        }
        jQuery(divId).empty();
        var labelName = this.state.label ? this.state.label : 'Label';
        // let mainLabel = ''
        // labelName.map((e) => mainLabel = e)
        // columnSize.forEach((item) => {if(item[0] === mainLabel){mainColumnWidth = item[1]}})
        var drillDown = reactObj.drillDown;
        var showTotalRow = reactObj.sum != null ? true : false;
        var setWidth = reactObj.setWidth ? true : false;
        var width = reactObj.width ? reactObj.width : null;
        var mainHeaderDef = []
        var mainColumnDef = [];
        var shortenHandle = reactObj.shortenHandle==true || reactObj.shortenHandle=='true' ? true : false;

        metricGlobal = reactObj.metricGlobal ? reactObj.metricGlobal : metricGlobal;
        
        if(metricGlobal && shortenHandle)
            var property_width = reactObj.mainMetric ? reactObj.mainMetric[0].property_width : metricGlobal[0].property_width;
        else property_width=null;

        /* Commented below code where in case of crosstab - column name comes with word 'by' */
        // if (reactObj.transpose === false || reactObj.transpose == 'false' || kpiMonitoringFlag == false || kpiMonitoringFlag == 'false') {
        //     if (reactObj.data.propertyHeaders && reactObj.data.propertyHeaders.length > 0 && reactObj.selectedMetric.split(',').length == 1) {
        //         var temp_metric_label = refineData(reactObj.selectedMetric, reactObj.mainMetric ? reactObj.mainMetric : metricGlobal, metricFunction);
        //         if (labelName && labelName.length > 1) {
        //             let tempLabelName = []
        //             labelName.map(function (innerLabel) {
        //                 tempLabelName.push(`${temp_metric_label.label} by ${innerLabel}`)
        //             })
        //             labelName = tempLabelName
        //         } else labelName = temp_metric_label.label + " by " + labelName;
        //         is_header_size_increase = true
        //     }
        // }
        if(screen_width<=mobile_width){
            is_header_size_increase=true
        }
        
        var columnDef = [];
        var labelNameArray = Array.isArray(labelName) ? labelName : Array(labelName);
        var length = (labelNameArray.length)-1;
        
        var pinned = true;
        var column_width=null;
        
        // columnSize.forEach((e) => console.log(e[1]))
        // alert('im here')
        // for(let item in columnSize){
        //     console.log(item, columnSize[item])
        // }
        // columnWidth.map((item) => console.log(item))   
        var multiDimGroup=that.props.multiDimGroup!=false && that.props.multiDimGroup!= undefined && that.props.multiDimGroup!="undefined" && that.props.multiDimGroup!="false" ? true:false;

        if(labelNameArray.length>1 || this.props.dashboard=='insight'){
            pinned=false;
        }

        /* KPI Montoring Changes */
        // if(kpiMonitoringFlag && reactObj.shortName && reactObj.shortName.length > 0) {
        if(kpiMonitoringFlag == true || kpiMonitoringFlag == 'true') {
            labelNameArray = ['Metrics']
        }

        labelNameArray.map(function(value, index) {
            columnSize.length > 0 && columnSize.forEach((item) => {if(item[0] === value){mainColumnWidth = item[1]}})
            var rowGroup = false;
            var hide = false;
            if(index!=length && multiDimGroup){
                rowGroup=true;
                hide=true;
            }
            // if(pinned)
            //     pinned = hide ? false : true;
            let fieldLabel = 'label' + (!index ? '' : index);
            let obj = {
                headerName: value,
                field: fieldLabel,
                // width: property_width?parseInt(property_width):null,
                width: mainColumnWidth,
                minWidth: that.props.dashboardLayout == "33-33-33"? 20 : 50,
                // minWidth: mainColumnWidth,
                maxWidth: 250,
                pinned: pinned,
                rowGroup: rowGroup,
                hide: hide,
                cellStyle: {
                    'padding-left': '9px',
                    'font-size': '13px',
                    'font-weight': '500',
                    'border-right': 'solid 1px #bdc3c8',
                    'white-space': 'normal'
                },
                sortingOrder: ['asc', 'desc'],
                filter: "text",
                // cellRenderer: dateFormatter,
                // comparator: stringComparator,
                // enableRowGroup:true,
                // enablePivot:true,
                unSortIcon: true // to show sort on column which are not sorted
            }
            columnDef.push(obj);
        });
        
        if (this.state.link && this.state.pop) {
            columnDef[0].cellRenderer = function (params) {
                if (params.data.pop)
                    var value = "<a data-html='true' class='btn-link has-popover' data-content='" + params.data.pop + "' href='" + params.data.link + "' target='_blank' data-placement='right' data-title='Information' data-original-title style='cusron:pointer'>" + params.data.label + "</a>";
                else var value = "<a class='btn-link' href='" + params.data.link + "' target='_blank' style='cusron:pointer'>" + params.data.label + "</a>";
                return value;
            }
        }
        else if (this.state.link) {
            columnDef[0].cellRenderer = function (params) {
                var value = "<a class='btn-link' href='" + params.data.link + "' target='_blank' style='cusron:pointer'>" + params.data.label + "</a>";
                return value;
            }
        }
        else if (this.state.pop) {
            columnDef[0].cellRenderer = function (params) {
                if (params.data.pop)
                    var value = "<a data-html='true' class='btn-link has-popover' data-content='" + params.data.pop + "' data-placement='right' data-title='Information' data-original-title style='cusron:pointer'>" + params.data.label + "</a>";
                else var value = params.data.label;
                return value;
            }
        }
        var associateThis = this;
        var isLowerLabel = (Array.isArray(labelName) ? labelName[0] ? labelName[0].toLowerCase()=="label" : 'label' : labelName.toLowerCase()=="label");
        if(transposeGlobal == 'true' || transposeGlobal == true || kpiMonitoringFlag == true || kpiMonitoringFlag == 'true') {
            metricObjectGlobal = createCombination(reactObj.metricGlobal, metricFunction);
        } else {
            metricObjectGlobal = createCombination(reactObj.mainMetric ? reactObj.mainMetric : reactObj.metrics, metricFunction);
        }        
        if(isLowerLabel || reactObj.report===true)
            var metricsObject = metricObjectGlobal
        else var metricsObject = reactObj.mainMetric ? reactObj.mainMetric : reactObj.metrics;
        mainColumnDef=columnDef;
        
        columnDef=[];
        if (reactObj?.data?.data != null) {  
            var shareVariable = '_ROCKMETRICSHARE';
            // var selectedMetric = kpiMonitoringFlag ? Object.values(reactObj.data.metric[0]).join(',') : reactObj.selectedMetric;
            var selectedMetric = reactObj.selectedMetric;
            var isSort = reactObj.sort ? reactObj.sort : true;
            var sortOrder = reactObj.sortOrder ? reactObj.sortOrder : 'desc';
            var sortMetric = (reactObj.tableType == 'trend' || reactObj.tableType == 'crosstab') ? selectedMetric?.split(',')[0] + ';' + reactObj.data?.propertyHeaders?.[0] : (reactObj.sortMetric ? reactObj.sortMetric : reactObj?.isSortRemoved ? selectedMetric.includes(',') ? selectedMetric.split(',')[0] : selectedMetric : null)
            var tempMetric = '';
            // if(!sortMetric){
            //     if (selectedMetric)
            //         tempMetric = selectedMetric.split(',')[0];
            //     jQuery(metricsObject).each(function (index, val) {
            //         if (val.value == tempMetric) {
            //             sortMetric = val.value;
            //             return false;
            //         }
            //     });
            // }
            var temp = [];
            var kpiMonitoringKeys = [];
            // var shareMetric = [];

            /* KPI Montoring Changes */
            // if (reactObj.kpiMonitoring && reactObj.shortName && reactObj.shortName.length > 0) {
            //     reactObj.data.metric.map(function (innerData) {
            //         Object.values(innerData).map(function (innerVal) {
            //             temp.push(innerVal)
            //         })
            //     })
            // } else {
                if (selectedMetric) {
                    temp = selectedMetric.split(',');
                }

                if(kpiMonitoringFlag == true || kpiMonitoringFlag == 'true') {
                    kpiMonitoringKeys = reactObj.shortNameKPI ? Object.keys(reactObj.shortNameKPI) : []
                }
            // }
            
            // var shareData = reactObj.data.data[0];
            // if(shareData){
            //     Object.keys(shareData).forEach(function(key) {
            //         if(key && key.indexOf(shareVariable) !== -1)
            //             temp.push(key);
            //     });
            // }
            var newMetricObject = [];
            if(lastRowFunction && transposeGlobal!=true && (kpiMonitoringFlag == false || kpiMonitoringFlag == 'false') && (window.location.pathname=="/dashboard/report" || window.location.pathname=="/dashboard/dashboard")) {
                var selectedMetricArray = this.props.selectedMetric.split(',');
                switch(lastRowFunction) {
                    case 'avg':
                    case 'mean':
                        lastRowFunction = 'Average';
                        break;
                    case 'sum':
                        lastRowFunction = 'Sum';
                        break;
                    case 'min':
                        lastRowFunction = 'Min';
                        break;
                    case 'max':
                        lastRowFunction = 'Max';
                        break;
                }
                var lastRowMetric = [];
                var appearedMetrics = [];
            }
            var mainHeaders = reactObj.mainHeaders && reactObj.mainHeaders.length ? reactObj.mainHeaders : [null]
            var propertyHeaders=reactObj.data.propertyHeaders;
            if(reactObj.data && reactObj.data.propertyHeaders && reactObj.data.propertyHeaders.length > 0){
                jQuery(mainHeaders).each(function (index, headerLabel) {
                jQuery(reactObj.data.propertyHeaders).each(function (index, propLabel) {
                    var tempMetricObject = [];
                    jQuery(metricsObject).each(function (index, val) {
                        if (jQuery.inArray(val.value, temp) > -1) {
                            val['information'] = typeof val['information'] == 'object' ? val['information'] : typeof val['information'] == 'undefined' ? null : jQuery.parseJSON(val['information']);
                            val['currentFunction'] = val['value'].split(';')[1];
                            // var tempIndex = jQuery.inArray(val.value, temp);
                            var tempArrayObject = JSON.parse(JSON.stringify(val));
                            // var newVal = jQuery.extend(true, {}, tempArrayObject);
                            if (headerLabel) {
                                tempArrayObject.label = tempArrayObject.label + ";" + propLabel + ";" + headerLabel;
                                tempArrayObject.value = tempArrayObject.value + ";" + propLabel + ";" + headerLabel;
                            } else {
                                tempArrayObject.label = tempArrayObject.label + ";" + propLabel;
                                tempArrayObject.value = tempArrayObject.value + ";" + propLabel;
                            }
                            // tempArrayObject.showShare = "false";
                            tempMetricObject[jQuery.inArray(val.value, temp)]=tempArrayObject;
                            if(lastRowFunction && transposeGlobal!=true && (kpiMonitoringFlag == false || kpiMonitoringFlag == "false") && propertyHeaders.length>last_row_function_min_month) {    // Create Average Row metric
                                var lastRowFunctionUpdated = lastRowFunction + ' Row';
                                var localVal = tempArrayObject.value.split(';');
                                localVal = localVal[0] + ';' + localVal[1];
                                if(!(jQuery.inArray(localVal,appearedMetrics) > -1)) {
                                    var newVal = jQuery.extend(true, {}, tempArrayObject);
                                    var label = newVal.label;
                                    var labelSplit = label.split(';');    // Total List Price;2016    // Replace 2016 with Function Name and remove Total
                                    label = label.replace(labelSplit[1], lastRowFunctionUpdated);    // Replace 20176 with 'lastRowFunction Row'
                                    var newLabel = label.split(' ');
                                    if(newVal['isDerived'] == '0')   // Remove 2nd word i.e, metricFunction (Total, Sum, Avg etc.) only for base metric
                                        newLabel.splice(0,1);  // Remove Total
                                    newVal.label = newLabel.join(' '); // new Label
                                    var tempValue = newVal.value.split(';');
                                    var tempValueLength = tempValue.length;
                                    tempValue[tempValueLength-1] = lastRowFunctionUpdated;
                                    newVal.value = tempValue.join(';');
                                    lastRowMetric[jQuery.inArray(localVal, selectedMetricArray)] = newVal;
                                    appearedMetrics.push(localVal);
                                }
                            }
                            // newMetricObject.push(tempArrayObject);
                            // if(val.defaultFormula)
                            //     var newMet = smallFirstLetter(tempArrayObject.value) + shareVariable;
                            // else 
                            // var newMet = tempArrayObject.value + shareVariable;
                            // if(jQuery.inArray(newMet, temp) > -1) {
                            //     newVal.label = newVal.label + ' (% Share)' +";"+ propLabel;
                            //     newVal.value = newMet;
                            //     newVal.metricPrefix = false;
                            //     newVal.metricUnit = '%';
                            //     newVal.numberShorten = 'in';
                            //     newVal.showShare = "true";
                            //     temp.splice(tempIndex, 0, newMet);
                            //     tempMetricObject.splice(tempIndex, 0, tempArrayObject);
                            //     tempMetricObject[tempIndex+1]=newVal;
                            // }
                        }
                    });
                    newMetricObject=newMetricObject.concat(tempMetricObject);
                });
                })
            }
            else { 
                jQuery(metricsObject).each(function (index, val) {
                    // let valueToMatch = kpiMonitoringFlag ? val.shortName : val.value
                    let valueToMatch = val.value
                    // let arrayToCheck = kpiMonitoringFlag ? kpiMonitoringKeys : temp
                    let arrayToCheck = temp
                    if (jQuery.inArray(valueToMatch, arrayToCheck) > -1) {
                        // valueToMatch = reactObj.kpiMonitoring ? reactObj.shortNameKPI[valueToMatch] : valueToMatch
                        var tempIndex = jQuery.inArray(valueToMatch, temp);                          
                        // val.showShare = "false";
                        
                        val = changeNumberFormat(val,selectedProperty);

                        val['currentFunction'] = val['value'].split(';')[1];
                        newMetricObject[tempIndex]=val;
                        // if(val.defaultFormula)
                        //     var newMet = smallFirstLetter(val.value) + shareVariable;
                        // else 
                        // var newMet = val.value + shareVariable;
                        // if(jQuery.inArray(newMet, temp) > -1) {
                        //     var newVal = jQuery.extend(true, {}, val);
                        //     newVal.label = val.label + ' (% Share)';
                        //     newVal.value = newMet;
                        //     newVal.metricPrefix = false;
                        //     newVal.metricUnit = '%';
                        //     newVal.numberShorten = 'in';
                        //     newVal.showShare = "true";
                        //     temp.splice(tempIndex, 0, newMet);
                        //     newMetricObject.splice(tempIndex, 0, val);
                        //     newMetricObject[tempIndex+1]=newVal;
                        // }
                    } 
                    // else {
                    //     var fullMet = val.defaultFormula + ' ' + val.label;
                    //     var newMet = fullMet + shareVariable;
                    //     if(jQuery.inArray(newMet, temp) > -1) {
                    //         val.label = ucwords(fullMet) + ' (% Share)';
                    //         val.value = newMet;
                    //         val.metricPrefix = false;
                    //         val.metricUnit = '%';
                    //         val.numberShorten = 'in';
                    //         val.showShare = "true";
                    //         newMetricObject[jQuery.inArray(newMet, temp)]=val;
                    //     }
                    // }
                });
            }
            
            if(lastRowFunction && transposeGlobal!=true && (kpiMonitoringFlag == false || kpiMonitoringFlag == 'false') && this.props.period) {
                newMetricObject = jQuery.merge(newMetricObject, lastRowMetric);
            }            
            if(isLowerLabel || reactObj.report===true)
                metricsObject = newMetricObject.length ? newMetricObject : metricsObject;            
            var labelTemp = null;
            var labelHeadTemp = null
            var insert = false;
            var period = this.props.period;
            
            // Commented the case. Check for which case this case was used
            // if(reactObj.propertyDisp && transposeGlobal){
            //     // metricsObject.push({"label":"Label 1",value:"label1"});
            //     metricsObject=[{"label":"Label 1",value:"label1",type:"string"}].concat(metricsObject);
            //     transposeGlobal=false;
            // }
            jQuery.each(metricsObject, function (index, val) {
                var information = val && val.information ? val.information : null;
                var isPositive = val && val.isPositive == '0' ? 0 : 1
                
                if(refineURLData(information)){
                    information = typeof(information)=="string" ? JSON.parse(information) : information;
                    if(information.header && information.header.width && reactObj.index){
                        is_header_size_increase=shortenHandle ? true : false;
                        val.width=information.header.width && shortenHandle? information.header.width : null;
                        val.color = information.header.color;
                    }
                }
                if(val && val.value && val.label) {                   
                    if (val.associateColumn) {
                        var temp = [];
                        temp['associateColumn'] = val.associateColumn;
                        temp['isColor'] = val.isColor;
                        temp['isPercent'] = val.isPercent;
                        temp['roundOff'] = val.roundOff;
                        associateColumnData[val.value] = temp;
                    }                    
                    var obj = {};
                    var condition = val.sort != 'null' && val.sort != 'NULL' && val.sort;
                    if (condition) {
                        sort = [
                            { colId: val.value, sort: val.sortOrder }
                        ];                    
                        isSort = false;
                    } else {
                        if (isSort) {
                            sort = [
                                { colId: sortMetric, sort: sortOrder }
                            ];                        
                            isSort = false;
                        }
                    }
                    var append =  '';
                    var $append = val?.value?.includes('cagr') ? "%" : '';
                    var prefix = '';
                    var $prefix = '';
                    var roundOff = 0;
                    var $roundOff = 0;
                    var color = false;
                    var showShare = val.showShare;
                    showShare = showShare == 'false' || !showShare ? false : true;
                    if (val.metricUnit != null && val.metricUnit != '') {
                        append = val.value.includes('cagr') ? "%" : val.metricUnit;
                        color = val.color ? true : false;
                        $append = append;
                        prefix = val.metricPrefix;
                        $prefix = prefix;
                        roundOff = val.roundOff;
                        $roundOff = parseInt(roundOff);
                    }
                    else {
                        roundOff = val.roundOff;
                        $roundOff = parseInt(roundOff);
                    }
                    var $numberShorten = val?.value?.includes('cagr') ? "%" : val.numberShorten;
            
                    var label = val.label ? val.label.split(';') : val.label;
                    var labelVal = val.value ? val.value.split(';') : val.value;
                    // if(labelVal[2] && labelVal[2].indexOf('_') > -1) {
                    //     label[0] = labelVal[0];
                    //     label[2] = labelVal[2].split('_')[0];
                    // }
                    if (reactObj.selectedMetric) {
                        if (reactObj.selectedMetric.split(',').length >= 1) {
                            if (label[1] != labelTemp && labelTemp) {
                                if (mainColumnDef.length) {
                                    if (reactObj.mainHeaders && reactObj.mainHeaders.length) {
                                        mainHeaderDef.push({ headerName: labelTemp, marryChildren: true, children: columnDef });
                                        if (label[2] != labelHeadTemp) {
                                            mainColumnDef.push({ headerName: labelHeadTemp, marryChildren: true, children: mainHeaderDef });
                                            mainHeaderDef = []
                                        }
                                    } else mainColumnDef.push({ headerName: labelTemp, marryChildren: true, children: columnDef }); // Removed b tag for correcting headers after exporting file
                                } else {
                                    mainColumnDef = columnDef;
                                }
                                columnDef = [];
                            }
                        } else label = [label[1] ? label[1] : label[0]];
                    } else label = label ? [label[1] ? label[1] : label[0]] : ['Blanks']; // To handle the case in tranpose when 1st label is null
                    labelHeadTemp = label ? label[2] : ['Blanks']
                    labelTemp = label ? label[1] : ['Blanks'];
                    label = labelVal ? (labelVal[1] && labelVal[1].indexOf('_') > -1 ? val.label : label[0]) : ['Blanks'];
                    var suppressFilter = false;
                    var filter;
                    var filterParams;
                    var comparatorVal;
                    
                    var cellStyle;
                    if (val.label == 'Date Time' || val.label == 'DateTime' || val.label == 'Date Modified') {
                        filter = 'date';
                        filterParams = {};
                        filterParams.comparator = function (filterLocalDateAtMidnight, cellValue) {
                            var dateAsString = cellValue;
                            var dateParts = dateAsString.split("-");
                            var timeParts = (dateParts[3].trim()).split(":");
                            var cellDate = new Date(Number(dateParts[0]), Number(dateParts[1]), Number(dateParts[2]), Number(timeParts[0]), Number(timeParts[1]), Number(timeParts[2]));
    
                            if (filterLocalDateAtMidnight.getTime() == cellDate.getTime()) {
                                return 0
                            }
    
                            if (cellDate < filterLocalDateAtMidnight) {
                                return -1;
                            }
    
                            if (cellDate > filterLocalDateAtMidnight) {
                                return 1;
                            }
                        };
                        suppressFilter = true;
                    }
                    else { 
                        filter = val.type == undefined || val.type == 'order' || val.type == 'number' || val.type == '1' || val.type == '2' ? 'number' : val.type;
                        filterParams = null;
                    }
                    if (val.label == 'Date Time' || val.label == 'Date Modified') {
                        comparatorVal = dateComparator;
                    }
                    else {
                        comparatorVal = filter == 'number' ? numberComparator : stringComparator;
                    }
                    if (filter == 'number'){
                        cellStyle = { 'text-align': 'right', 'padding-right': '2px' };
                        filter="agNumberColumnFilter";
                    }
                    else {
                        cellStyle = { 'padding-left': '2px' };
                        filter='agTextColumnFilter';
                    }
                    if(val.width && val.width<150 && is_header_size_increase===false && shortenHandle)
                        is_header_size_increase=true;
                    column_width=val.width && shortenHandle ?parseInt(val.width):null;
                    // var column_width=val.width ?parseInt(val.width):null;
                    
                    // if(val.defaultFormula)
                    //     var field_value=val.label.charAt(0).toLowerCase() + val.label.slice(1);
                    // else var field_value=val.label;
                    if(val.child && reactObj.index==-100){
                        label=label + "<br><a class='fa fa-level-down' onclick=table_drill_handle(\'"+val.child.trim()+"\')></a>";
                        // is_header_size_increase=true;
                    }
                    cellStyle=jQuery.extend(cellStyle,{"border-right":'solid 1px #bdc3c8'});

                    var aggFunc = val.isAggregate=="1"?"sum":'avg';
                    var cellRenderer = function (params)
                    {  
                        var percentile = false;
                        var mainLabel = params.column.colDef.field;
                        let tempIsPositive = params.column.colDef.isPositive; 
                        isPositive = tempIsPositive && tempIsPositive.isPositive == '0' ? 0 : isPositive                        
                        let metricColor = params.column.colDef.information ? params.column.colDef.information.metricColor : null
                        if(!params.data || !mainLabel){
                            return ;
                        }                        
                        var value = params.data[mainLabel];
                        if(mainLabel && mainLabel.indexOf("percentile")>1){
                            $roundOff=2;
                            $numberShorten="in";
                            // $append="% ile";
                            $prefix="false";
                            var percentile = true;
                        }
                        if(params.data['label']==="Total") {
                            
                            if(mainLabel.indexOf("percentile")>1) {
                                value="N.A";    // Show N.A. in Total Row
                                $roundOff=2;
                                $numberShorten = "in";
                                $append = val?.value?.includes('cagr') ? "%" : "";
                                $prefix="none";
                            } 
                            // Show growth as 'N.A.' in Total row
                            // else if(mainLabel.indexOf('_growth')>1) {
                            //     value='N.A.';
                            // }
                            else if(lastRowFunction && transposeGlobal!=true && (kpiMonitoringFlag == false || kpiMonitoringFlag == 'false')) {
                                var splitMainLabel = mainLabel.split(';');
                                var mainLabelLanght = splitMainLabel.length-1;
                                if(splitMainLabel[mainLabelLanght] == lastRowFunction + ' Row') {
                                    // value="N.A";    // Show N.A. in Total Row
                                    // value = value ? (isNaN(value.replace( /,/g, "" )) ? 'N.A.' : value):"N.A";
                                    value = value ? value : "N.A";
                                }
                            }
                        }
                        if(transposeGlobal == 'true' || transposeGlobal == true || kpiMonitoringFlag == true || kpiMonitoringFlag == "true") {
                            var label = kpiMonitoringFlag == true || kpiMonitoringFlag == 'true' ? reactObj.shortName[reactObj.data.metric[params.data['label']]][mainLabel] : params.data['label'];
                            var metIndex = getIndexOfMetric(label, kpiMonitoringFlag == true || kpiMonitoringFlag == 'true' ? 'value' : 'label');
                            if(metIndex == -1) {
                                $roundOff=2;
                                $numberShorten="in";
                                $append=val?.value?.includes('cagr') ?"%":"";
                                $prefix="none";
                            } else {
                                // var transposeMetricArray = reactObj.mainMetric ? reactObj.mainMetric[metIndex] : metricGlobal[metIndex];
                                var transposeMetricArray = params.column.colDef.information && params.column.colDef.information['roundOff'] ? params.column.colDef.information : metricObjectGlobal[metIndex];
                                $roundOff = transposeMetricArray['roundOff'];
                                $numberShorten = transposeMetricArray['numberShorten'];
                                $prefix = transposeMetricArray['metricPrefix'];
                                $append =val?.value?.includes('cagr') ?"%": transposeMetricArray['metricUnit'] ? transposeMetricArray['metricUnit'] : "";
                            }
                            var percentile = label ? (label.split(' ')[0] == 'Percentile' ? true : false) : false;
                        }
                        if(!value) {
                            mainLabel = params.column.colDef.colId;
                            value = params.data[mainLabel];
                            if(!value) {
                                // value=is_null_to_zero=='TRUE'?0:"-";
                                value = value == 0 ?0:"-";
                            }
                        }
                        // var shareLabel = mainLabel + '_ROCKMETRICSHARE';
                        // if(period && period.toLowerCase() != 'aggregate' && mainLabel) {
                        //     shareLabel = mainLabel.split(';');
                        //     shareLabel = shareLabel[0] + '_ROCKMETRICSHARE' + ';' + shareLabel[1];
                        // } 
                        // var shareValue = params.data[shareLabel];
                        // value = (value == undefined || value == '') && params.data['label']!='Total' ? 0 : value;
                        var shareValue = '';
                        var realValue = value;
                        if ((value || value==0 || value=='0') && !isNaN(parseFloat(value)) && value !== undefined) {
                            // shareValue = shareValue == undefined || shareValue == '' ? '' : ' (' + number_shorten(shareValue.toString(),2) + '%)';//to show percentage share
                            value = (mainLabel?.includes('cagr')) ? number_shorten(value, 2, $numberShorten) : value == undefined || value == '' ? number_shorten('0', $roundOff, $numberShorten) : number_shorten(value.toString(), $roundOff, $numberShorten);
                        }

                        // if (reactObj.sum !== null && reactObj.sum !== undefined && reactObj.sum !== false){
                        //     value = value == undefined || value == '' ? number_shorten('0', $roundOff, $numberShorten) : number_shorten(value.toString(), $roundOff, $numberShorten)
                        // }

                        // if(showShare) {
                        //     // booleanProperty specifies whether Total row should show 'N.A.' for '% Share' metric or not
                        //     // If there is/are property value/s or more than one property then Total should show 'N.A.' 
                        //     var booleanProperty = associateThis.state.data.property && ((associateThis.state.data.property.indexOf(';') > -1) || (associateThis.state.data.property.indexOf(',') > -1)) ? true : false;
                        //     if(params.data['label']=='Total') {
                        //         if(booleanProperty || (lastRowFunction && transposeGlobal!=true)) {
                        //             // Remove comma from value if it contains and then check if it is number of not 
                        //             value = isNaN(value.replace( /,/g, "" )) ? 'N.A.' : value;    // Check if value if number then show 100 otherwise N.A.. This case is only for % share
                        //         }
                        //         else if(value != 'N.A.')    // Handling the case for Rank KPI. Making it '-' here
                        //             value = mainLabel.toLowerCase().indexOf('rank')!=-1 ? '-' : number_shorten('100',2);
                        //     } 
                        //     // else value = value == undefined || value == '' ? 'N.A.' : value; 
                        //     else value = value == undefined || value == '' ? '0.00' : value; 
                        // }
                        // else value = value == undefined || value == '' ? '0.00' : value;

                        var $newAppend = metricUnitPlacement && metricUnitPlacement === "1" ? '' : $append;
                        if(value == 'N.A.' || value == '-') {
                            $newAppend = '';
                        } 
                        if (associateColumnData[mainLabel]) {
                            value = associateThis.getAssociateColumnData(params.data, value, mainLabel);
                        }
                        var signUsed='';
                        var floatValue = parseFloat(realValue);                        
                        if(percentile) {
                            color = true;
                            var colorUsed = '';
                            var signUsed = '';
                            if (floatValue >= 0) {
                                signUsed = '';  
                                if(floatValue <= 20) {
                                    value = 'Top 20%';
                                    colorUsed = 'DarkGreen';
                                }
                                else if(floatValue <= 40) {
                                    value = 'Top 40%';
                                    colorUsed = 'Lime';
                                }
                                else if(floatValue <= 60) {
                                    value = 'Top 60%';
                                    colorUsed = '#caca0e';
                                }
                            } else {
                                if(!isNaN(floatValue)) {
                                    if(floatValue <= -40) {
                                        value = 'Bottom 40%';
                                        colorUsed = 'LightPink';
                                    }
                                    else if(floatValue <= -20) {
                                        value = 'Bottom 20%';
                                        colorUsed = 'Red'
                                    }
                                }                                     
                            }
                        } else {
                            // if (floatValue >= 0) {
                            //     var colorUsed = 'green';
                            //     var signUsed = '+';
                            //     color = false;
                            //     if(!isPositive) {
                            //         colorUsed = 'red';
                            //         signUsed = '';
                            //         color = true;
                            //     }
                            // } else {
                            //     if(!isNaN(floatValue)) {
                            //         var colorUsed = 'red';
                            //         var signUsed = '';
                            //         color = true;
                            //         if(!isPositive) {
                            //             colorUsed = 'green';
                            //             signUsed = '';
                            //             color = true;
                            //         }
                            //     }                            
                            // }
                        }
                        // if($newAppend==="%"){
                        //     colorUsed=realValue>=75?"green":"red";
                        //     color=true;
                        // }
                        if(metricColor) {
                            colorUsed = metricColor
                            color = true
                            signUsed = ''
                        }
                        var fontWeight = params.data['label']==="Total"? 600 : 500
                        var paddingRight = "padding-right:5px";
                        if ($prefix == 'true')
                            return '<span class="rag-element" style="font-size:13px;font-weight:600;' + paddingRight + '">'+$newAppend + ' ' + value + '' + shareValue +'</span>';
                        if (color)
                                return '<span class="rag-element" style="font-size:13px;font-weight:500;color:' + colorUsed + ';' + paddingRight + '">' + signUsed + '' + value + ' ' + $newAppend +'' + shareValue +'</span>';
                            // return '<span class="rag-element" style="color:' + colorUsed + ';' + paddingRight +'>' + signUsed + '' + value + ' ' + $newAppend + '' + shareValue + '<span>';
                        return '<span class="rag-element" style="font-size:13px;font-weight:'+fontWeight +';'+ paddingRight + '">'+value + ' ' + $newAppend + '' + shareValue +'</span>';
                    }
                    
                    val.shortName = val.shortName && shortenHandle ? (val.shortName == '% Share' ? '% Share' : isJson(val.shortName) ? JSON.parse(val.shortName) : null) : null;
                    val.shortName = val.shortName && val.shortName[val.currentFunction] ? val.shortName[val.currentFunction] : (val.shortName && val.shortName["default"]?val.shortName["default"]:null);
                    
                    label = shortenHandle && (kpiMonitoringFlag == true || kpiMonitoringFlag == 'true') ? (val.shortName ? (reactObj.selectedMetric.split(',').length==1 && propertyHeaders && propertyHeaders.length!=0 ? label : val.shortName) : label) : label;
                    val.color = val.color ? val.color : null;
                    let numberShorten = val.numberShorten && val.numberShorten !== 'in'
                        ? val.numberShorten.charAt(0).toUpperCase() + val.numberShorten.slice(1)
                        : '';
                    let metricUnit = val.metricUnit
                        ? val.metricUnit.trim() ===
                            '%'
                            ? val.metricUnit.trim()
                            : `${val.metricUnit} in `
                        : '';

                    /* KPI Montoring Changes */
                    if ((kpiMonitoringFlag == true || kpiMonitoringFlag == 'true') && reactObj.shortName && reactObj.shortName.length > 0) {
                        reactObj.shortName.map(function (innerVal) {
                            if (innerVal[val.value]) {
                            label = innerVal[val.value]
                            }
                        })
                    }
                    // Conditional Formatting                    
                    var cellStyleFinal = function (params) {
                        let appendParam = params.colDef.field ? (params.colDef.field).split(';') : []
                        if (reactObj.tableType == 'crosstab' && reactObj.period && reactObj.period.toLowerCase() !== 'aggregate') {
                            appendParam = appendParam.length > 2 && appendParam.length == 4 ? `${appendParam[2]};${appendParam[3]}` : null
                        } else appendParam = appendParam.length > 2 ? appendParam.pop() : null

                        if (kpiMonitoringFlag == true || kpiMonitoringFlag == 'true')
                            return handleKPIMonitoringCF(params, cellStyle, reactObj);
                        else return handleConditionalFormatting(params, information, val, cellStyle, 'report', appendParam, kpiMonitoringFlag);
                    };
                    columnSize.length > 0 && columnSize.forEach((item) => {if(item[0] === label){mainColumnWidth = item[1]}})
                    
                    obj = {
                        headerName: metricUnitPlacement && metricUnitPlacement === "1" && (numberShorten || metricUnit) ? `${label} (${metricUnit}${numberShorten})` : label,
                        field: val.value,
                        headerColor: val.color,
                        colId: val.value,
                     // headerTooltip: fullLabel,
                     // tooltipShowDelay: 500,
                        isPositive: val.isPositive,
                        information: val.information,
                        width: mainColumnWidth,
                        exportNumberShorten: numberShorten,
                        exportMetricUnit: metricUnit,
                        // minWidth: column_width?column_width:100,
                        // minWidth: mainColumnWidth,
                        minWidth:that.props.dashboardLayout == "33-33-33"? 20 : 130,
                        maxWidth: 300,
                        // cellStyle: cellStyle,
                        cellStyle: cellStyleFinal,
                        cellClass: "ag-cell-class",
                        filter: filter,
                        suppressFilter: suppressFilter,
                        comparator: comparatorVal,
                        aggFunc: aggFunc,
                        sortingOrder: ['asc', 'desc'],
                        enableValue:filter==='number'?true:false,
                        cellRenderer: cellRenderer,                        
                        unSortIcon: true,  // to show sort on column which are not sorted
                        cellClass: `numberType${val.roundOff}` , // handle excel data download format
                        headerTooltip:`${val.label.split(";")[0]}`,                  
                    }
                    columnDef.push(obj);
                    if (selectedMetric) {
                        var metricArray = selectedMetric.split(',');
                        var flag = false;
                        metricArray.forEach(function (metricValue, index) {
                            if (metricValue == val.value) {
                                flag = true;
                                return false
                            }
                        });
                        if (!flag)
                            obj.hide = false;
                    }   
                }
            });
        }
        if(mainColumnDef.length){
            if(labelTemp)
                if(labelHeadTemp) {
                    mainHeaderDef.push({ headerName: labelTemp, marryChildren: true, children: columnDef });
                    mainColumnDef.push({ headerName: labelHeadTemp, marryChildren: true, children: mainHeaderDef })
                } else
                //mainColumnDef.push({headerName:"<b>"+labelTemp+"<b>",marryChildren:true,children:columnDef});
                mainColumnDef.push({headerName:labelTemp,marryChildren:true,children:columnDef}); // Removed b tag for correcting headers after exporting file
            else mainColumnDef=mainColumnDef.concat(columnDef);
        }else{
            mainColumnDef=columnDef;
        }
        var height_auto=null;

        var ag_header_height = 35;
        var ag_header_height_double = 50;
        
        var enableSorting = transposeGlobal || kpiMonitoringFlag == 'true' || kpiMonitoringFlag == true  ? false : true;
        var largeData=reactObj.data.data.length>2000?true:false;
        var defaultColDef={resizable: true, sortable: true, wrapText: true, autoHeight: true, wrapHeaderText: true, autoHeaderHeight: true,suppressMenu: this.props.dashboardLayout == "33-33-33"? true : false   };

        var groupUseEntireRow=false;
        let mobile = jQuery(document).width() < mobile_width || jQuery(document).width() < tablet_width 
        if(multiDimGroup)
            groupUseEntireRow=true;
        gridOptions = {
            columnDefs: mainColumnDef,
            rowHeight: 35,
            metricsObject: metricsObject,
            excelStyles: [  // handle excel data download format id
                {
                  id: 'numberType0',
                  numberFormat: {
                    format: '0',
                  },
                },
                {
                  id: 'numberType1',
                  numberFormat: {
                    format: '###0.0',
                  },
                },
                {
                  id: 'numberType2',
                  numberFormat: {
                    format: '###0.00',
                  },
                },{
                  id: 'numberType3',
                  numberFormat: {
                    format: '###0.000',
                  },
                },{
                  id: 'numberType4',
                  numberFormat: {
                    format: '###0.0000',
                  },
                },{
                  id: 'numberType5',
                  numberFormat: {
                    format: '###0.00000',
                  },
                },{
                  id: 'numberType6',
                  numberFormat: {
                    format: '###0.000000',
                  },
                },{
                  id: 'numberType7',
                  numberFormat: {
                    format: '###0.0000000',
                  },
                },{
                  id: 'numberType8',
                  numberFormat: {
                    format: '###0.00000000',
                  },
                },{
                  id: 'numberType9',
                  numberFormat: {
                    format: '###0.000000000',
                  },
                },{
                  id: 'numberType10',
                  numberFormat: {
                    format: '###0.0000000000',
                  },
                },
            ],
            groupUseEntireRow: groupUseEntireRow,
            components: {
                groupRowInnerRenderer: GroupRowInnerRenderer,
                // customLoadingCellRenderer: CustomLoadingCellRenderer,
                loadingCellRenderer: function (params) {
                    if (params.value !== undefined) {
                        return params.value;
                    } else {
                        return '<img src="https://www.ag-grid.com/example-assets/loading.gif">';
                    }
                },
            },
            // loadingCellRenderer: 'customLoadingCellRenderer',
            // loadingCellRendererParams: {
            //     loadingMessage: 'One moment please...',
            // },
            groupRowInnerRenderer: 'groupRowInnerRenderer',
            groupDefaultExpanded: -1,
            // pagination: true,
            // paginationPageSize: 20,
            suppressAggFuncInHeader: true,

            defaultColDef: defaultColDef,
            onColumnResized: mobile ? this.onColumnResized : null,
            onGridReady: mobile ? this.onGridReady :null,
            overlayLoadingTemplate: '<span className="ag-overlay-loading-center">Please wait while your rows are loading</span>',
            rowData: reactObj.data.data,
            enableSorting: enableSorting,
            enableFilter: true,
            // suppressColumnVirtualisation:true,
            debug: false,
            enableColResize: true,
            getRowStyle: function (params) {
                if (params.node.floating) {
                    return { 'font-weight': 'bold' }
                }
            },
            // domLayout: height_auto,
            // rowModelType: (reactObj.propertyDisp && reactObj.propertyDisp.length > 1 && reactObj.multiDim === false) ? '' : largeData ? 'infinite': '',
            rowModelType: (reactObj.multiDim === false) ? '' : largeData ? 'infinite': '',
            cacheOverflowSize: 2,
            maxConcurrentDatasourceRequests: 1,
            infiniteInitialRowCount: 100,
            maxBlocksInCache: 10,
            //suppressMenuMainPanel: true,//menuTabs=['filterMenuTab','columnsMenuTab']
            //suppressMenuColumnPanel: true,//menuTabs=['generalMenuTab','filterMenuTab']
            headerHeight: is_header_size_increase?(ag_header_height_double):(ag_header_height),
            animateRows: true,
            enableRangeSelection: true,
            // rowSelection: 'multiple',
            sideBar:{
                toolPanels: [{
                    id: 'columns',
                    labelDefault: 'Columns',
                    labelKey: 'columns',
                    iconKey: 'columns',
                    toolPanel: 'agColumnsToolPanel',
                    toolPanelParams: {
                        suppressRowGroups: true,
                        suppressValues: true,
                        suppressPivots: true,
                        suppressPivotMode: true,
                        suppressSideButtons: true,
                        suppressColumnFilter: true,
                        suppressColumnSelectAll: true,
                        suppressColumnExpandAll: true
                    }
                }],
                defaultToolPanel: 'columns'
            },
            clipboardDeliminator: ',',
            onSortChanged:function(e){
                if(largeData){
                    if(gridOptions.api.getSortModel()!=0){
                        var sortMetric=gridOptions.api.getSortModel()[0].colId;
                        var sortOrder=gridOptions.api.getSortModel()[0].sort;
                        if((reactObj.sortOrder!=sortOrder && sort[0].sort!=sortOrder) || (reactObj.sortMetric!=sortMetric && sort[0].colId!=sortMetric)){
                            that.setState({
                                sort: true,
                                sortOrder: sortOrder,
                                sortMetric: sortMetric,
                                data: {
                                    data: reactObj.data.data,
                                    metric: reactObj.data.metric,
                                    property: reactObj.data.property,
                                    propertyHeaders: reactObj.data.propertyHeaders
                                }
                            })
                            that.createTable(that.state);
                        }
                    }
                }
            },
            onFilterModified: function () { gridOptions.api.setPinnedBottomRowData() },
            // getRowNodeId: function (item) { 
            //     return item.id;
            // },
            // components: { 
            //     loadingCellRenderer: function (params) { 
            //         if (params.value !== undefined) {
            //             return params.value;
            //         } else {
            //             return '<img src="https://www.ag-grid.com/example-assets/loading.gif">';
            //         }
            //     },
            // },
            
        };
        
        if (showTotalRow !== false) {
            gridOptions['pinnedBottomRowData'] = [];
        }
        if (reactObj.drillAcross && reactObj.index === 1 || (reactObj.dashboard && reactObj.index > 1) || reactObj.kpiMonitoring == 'true' || reactObj.kpiMonitoring == true) {
            drillObj = reactObj.drillAcross;
            gridOptions['getContextMenuItems'] = this.getContextMenuItems;
        }
        var bottomData;
        var eGridDiv = document.querySelector(divId);
        new agGrid.Grid(eGridDiv, gridOptions);
        gridOptionsAll[this.state.index ? this.state.index : 0] = gridOptions;
        if (showTotalRow !== false) {
            // if (reactObj.sum[0]) {
            //     if (reactObj.sum[0].label != 'all')
            //         bottomData = [refineTotalData(reactObj.sum, metricsObject)];
            //     else {
            //         reactObj.sum[0].label = 'Total';
            //         bottomData = reactObj.sum;
            //     }
            // }
            // else 
            bottomData = [refineTotalData(reactObj.sum, metricsObject, reactObj.period, labelNameArray)];
            gridOptions.api.setPinnedBottomRowData(bottomData);
        }
        gridOptions.api.closeToolPanel();
        if (enableSorting && reactObj?.period?.toLowerCase() != 'aggregate' && reactObj?.period != null && reactObj?.period != undefined && reactObj?.period?.toLowerCase() != "" && reactObj?.propertyDisp?.length > 0 && reactObj?.propertyDisp?.length == 1) {
            let lastHeader = gridOptions.columnDefs.length > 0 ? (gridOptions.columnDefs[gridOptions?.columnDefs?.length - 1].children ? gridOptions.columnDefs[gridOptions?.columnDefs?.length - 1].children?.[0] : gridOptions.columnDefs[gridOptions?.columnDefs?.length - 1]) : null;
            if (lastHeader) {
                gridOptions.api.setSortModel([{ colId: lastHeader?.colId ? lastHeader?.colId : lastHeader?.colId, sort: sortOrder }]);
            } else {
                gridOptions.api.setSortModel(sort);
            }
        } else if (enableSorting)
            gridOptions.api.setSortModel(sort);
        if (setWidth)
            gridOptions.api.sizeColumnsToFit();

        function sortAndFilter(allOfTheData, sortModel, filterModel) {
            return sortData(sortModel, filterData(filterModel, allOfTheData));
        }

        function sortData(sortModel, data) {
            var sortPresent = sortModel && sortModel.length > 0;
            if (!sortPresent) {
                return data;
            }
            // do an in memory sort of the data, across all the fields
            var resultOfSort = data.slice();
            resultOfSort.sort(function (a, b) {
                for (var k = 0; k < sortModel.length; k++) {
                    var sortColModel = sortModel[k];
                    var valueA = a[sortColModel.colId];
                    var valueB = b[sortColModel.colId];
                    // this filter didn't find a difference, move onto the next one
                    if (valueA == valueB) {
                        continue;
                    }
                    var sortDirection = sortColModel.sort === 'asc' ? 1 : -1;
                    if (valueA > valueB) {
                        return sortDirection;
                    } else {
                        return sortDirection * -1;
                    }
                }
                // no filters found a difference
                return 0;
            });
            return resultOfSort;
        }

        function filterData(filterModel, data) {
            var filterPresent = filterModel && Object.keys(filterModel).length > 0;
            if (!filterPresent) {
                return data;
            }
            let columns = Object.keys(data[0]);

            var resultOfFilter = [];
            for (var i = 0; i < data.length; i++) {
                var item = data[i];

                for (var j = 0; j < columns.length; j++) {                
                    let val = item[columns[j]]
                    let filterVal = filterModel[value].filter
                    let filterType = filterModel[value].type
                    let type = typeof val;
                    switch(type) {
                        case 'number':
                            filterVal = parseFloat(filterVal)
                            switch(filterType) {
                                case 'equal':
                                    if(val != filterVal) continue;
                                    break;
                                case 'lessThan':
                                    if(val >= filterVal) continue;
                                    break;
                                default:
                                    if(val <= filterVal) continue;
                                    break;
                                    
                            }
                            break;
                        case 'string':
                                if(filterVal.values.indexOf(val) < 0)
                                    continue;
                            break;
                        case 'date':
                            break;
                    }
                };
                resultOfFilter.push(item);
                // if (filterModel.age) {
                //     var age = item.age;
                //     var allowedAge = parseInt(filterModel.age.filter);
                //     // EQUALS = 1;
                //     // LESS_THAN = 2;
                //     // GREATER_THAN = 3;
                //     if (filterModel.age.type == 'equals') {
                //         if (age !== allowedAge) {
                //             continue;
                //         }
                //     } else if (filterModel.age.type == 'lessThan') {
                //         if (age >= allowedAge) {
                //             continue;
                //         }
                //     } else {
                //         if (age <= allowedAge) {
                //             continue;
                //         }
                //     }
                // }

                // if (filterModel.year) {
                //     if (filterModel.year.values.indexOf(item.year.toString()) < 0) {
                //         // year didn't match, so skip this record
                //         continue;
                //     }
                // }

                // if (filterModel.country) {
                //     if (filterModel.country.values.indexOf(item.country) < 0) {
                //         continue;
                //     }
                // }

                // resultOfFilter.push(item);
            }

            return resultOfFilter;
        }
        if(screen_width<=mobile_width){
            gridOptions.api.sizeColumnsToFit();
        }
        if(largeData){   // Data preparation for CellRenderer
            if(reactObj.multiDim === false){
                // if(sort){   
                //     var columnName=sort[0].colId;
                //     var columnSort=sort[0].sort;
                //     if(columnName && columnSort)
                //         var new_data=reactObj.data.data.sort(GetSortOrder(columnName,columnSort));
                //     var new_data=reactObj.data.data;
                // }else var new_data=reactObj.data.data;
    
                // var mockServer = new MockServer();
                // mockServer.init(new_data);
            
                // var viewportDatasource = new ViewportDatasource(mockServer);
                // gridOptions.api.setViewportDatasource(viewportDatasource);
                gridOptions.api.setRowData(reactObj.data.data);
            } else {
                let largeVolumeData = reactObj.data.data
                var dataSource = {
                    rowCount: null, // behave as infinite scroll
                    getRows: function (params) {
                      console.log('asking for ' + params.startRow + ' to ' + params.endRow);
                      setTimeout(function () {
                        var dataAfterSortingAndFiltering = sortAndFilter(
                          largeVolumeData,
                          params.sortModel,
                          params.filterModel
                        );
                        var rowsThisPage = dataAfterSortingAndFiltering.slice(
                          params.startRow,
                          params.endRow
                        );
                        var lastRow = -1;
                        if (dataAfterSortingAndFiltering.length <= params.endRow) {
                          lastRow = dataAfterSortingAndFiltering.length;
                        }
                        params.successCallback(rowsThisPage, lastRow);
                      }, 500);
                    },
                  };
                  gridOptions.api.setDatasource(dataSource);


                // let largeVolumeData = reactObj.data.data
                // var dataSource = {
                //     rowCount: null, // behave as infinite scroll
                //     getRows: function (params) {
                //       setTimeout(function () {
                //         var rowsThisPage = largeVolumeData.slice(params.startRow, params.endRow);
                //         var lastRow = -1;
                //         if (largeVolumeData.length <= params.endRow) {
                //           lastRow = largeVolumeData.length;
                //         }
                //         params.successCallback(rowsThisPage, lastRow);
                //       }, 500);
                //     },
                //   };
                //   gridOptions.api.setDatasource(dataSource);
                //   gridOptions.api.setRowData(reactObj.data.data);
            }
        } else gridOptions.api.setRowData(reactObj.data.data);
        // else if (reactObj.data.data.length > 0) {
        //     gridOptions.api.setRowData(reactObj.data.data);
        // } else gridOptions.api.showLoadingOverlay();

        jQuery("#toolPanel").unbind('click').click(function () { // unbind any previous click on toolPanel button because it was getting called twice on a single click
            if (gridOptions.api.isToolPanelShowing()) {
                _paq.push(['trackEvent', 'Edit', 'Report', 'Clicked']);
                gridOptions.api.closeToolPanel()
                // jQuery(this).html("Edit Report");
                // jQuery(divId).width("100%");
            }
            else {
                // jQuery(this).html("Hide Edit Report");
                gridOptions.api.openToolPanel("columns");
                // gridOptions.api.showToolPanel(true);
            }
        });

        var styleEl = document.createElement('style');
        document.head.appendChild(styleEl);
        var styleSheet = styleEl.sheet;

        if(!column_width){
            gridOptions.columnApi.sizeColumnsToFit(100);//This is done because it initially it is not visiable thats y it is been fixed first then gets updated to autofit            
            var allColumnIds = [];
            gridOptions.columnApi.getAllColumns().forEach(function(column) {
                allColumnIds.push(column.colId);
                let headerColor = column.colDef.headerColor;
                let field = column.colDef.field;
                if(headerColor){
                    styleSheet.insertRule(`.ag-header-cell[col-id="${field}"]{background-color: ${headerColor}}`);
                    // jQuery(`.ag-header-cell[col-id="${field}"]`).css("background-color", headerColor);
                    // jQuery(`.ag-header-cell[col-id=gross_amt;ytd_growth]`).css("background-color", "#ff0000");
                    // styleSheet.insertRule(`.ag-header-cell[col-id="gross_amt;ytd_growth"]{background-color: #ff0000}`);
                }
            });
            gridOptions.columnApi.autoSizeAllColumns(allColumnIds);
        }else {
            gridOptions.columnApi.getAllColumns().forEach(function(column) {
                let headerColor = column.colDef.headerColor;
                let field = column.colDef.field;
                if(headerColor){
                    styleSheet.insertRule(`.ag-header-cell[col-id="${field}"]{background-color: ${headerColor}}`);
                    // jQuery(`.ag-header-cell[col-id="${field}"]`).css("background-color", headerColor);
                    // jQuery(`.ag-header-cell[col-id=gross_amt;ytd_growth]`).css("background-color", "#ff0000");
                    // styleSheet.insertRule(`.ag-header-cell[col-id="gross_amt;ytd_growth"]{background-color: #ff0000}`);
                }
            });
        }
    }
    // CustomLoadingCellRenderer() {
    //     init(params) {
    //       this.eGui = document.createElement('div');
    //       this.eGui.innerHTML = `
    //               <div class="ag-custom-loading-cell" style="padding-left: 10px; line-height: 25px;">  
    //                   <i class="fas fa-spinner fa-pulse"></i> 
    //                   <span>${params.loadingMessage} </span>
    //               </div>
    //           `;
    //     }
      
    //     getGui() {
    //       return this.eGui;
    //     }
    // }
    onGridReady(params) {
        // Calculate the maximum length of column names
        // const headerCells = document.querySelectorAll('.ag-header-cell-text');
        //     let minHeight = 25;
        //     headerCells.forEach(cell => {
        //         minHeight = Math.max(minHeight, cell.scrollHeight);

        //     });
        //     params.api.setHeaderHeight(minHeight+10);
        //     // params.api.resetRowHeights();
        const headerCells = document.querySelectorAll('[role="columnheader"]');
        const headerGroupCells = document.querySelectorAll('.ag-header-group-text');
        // Loop through each header and apply the tooltip
        headerCells.forEach(cell => {
            // Get the tooltip content from the `title` attribute of the header
            const tooltipText = cell.innerHTML;

            // Add `data-toggle` and `data-placement` attributes for Bootstrap 4 tooltip
            if (tooltipText) {
                cell.style.marginTop = '3px';
                cell.setAttribute('data-toggle', 'tooltip');
                cell.setAttribute('data-placement', 'top');
                cell.setAttribute('title', tooltipText);

                // Initialize Bootstrap 4 Tooltip on this element
                $(cell).tooltip();  // Bootstrap 4 initialization
            }
        });
        headerGroupCells.forEach(cell => {
            // Get the tooltip content from the `title` attribute of the header
            const tooltipText = cell.innerHTML;

            // Add `data-toggle` and `data-placement` attributes for Bootstrap 4 tooltip
            if (tooltipText) {
                cell.style.marginTop = '3px';
                cell.setAttribute('data-toggle', 'tooltip');
                cell.setAttribute('data-placement', 'top');
                cell.setAttribute('title', tooltipText);

                // Initialize Bootstrap 4 Tooltip on this element
                $(cell).tooltip();  // Bootstrap 4 initialization
            }
        });
        // if (window.location.pathname === "/pinboard") {
        //     const element = document.querySelectorAll('.ag-icon.ag-icon-none');
        //     element.forEach(element => {
        //       element.style.marginTop = '-8px';
        //     });
        //   }
        

    }

    onColumnResized(params) {
        const MIN_HEIGHT = 25
        if (params.finished !== false) {
            params.api.setHeaderHeight(MIN_HEIGHT);
            const headerCells = document.querySelectorAll('.ag-header-cell-text');
            const headerIcons = document.querySelectorAll('.ag-icon-none');
            let minHeight = MIN_HEIGHT;
            headerCells.forEach(cell => {
                minHeight = Math.max(minHeight, cell.scrollHeight);
            });
            headerIcons.forEach((cell) => {
                cell.classList.add('ag-headerIconsMarginTopAdminPanel')
            })
            params.api.setHeaderHeight(minHeight+10);
            params.api.resetRowHeights();
        }
    }
    getAssociateColumnData(data, mainValue, mainLabel) {
        var columnData = associateColumnData[mainLabel];
        var value = data[columnData['associateColumn']];
        var color = columnData['isColor'] == 'true';
        if (color) {
            if (parseFloat(value) > 0) {
                var colorUsed = 'green';
                var signUsed = '+';
            } else {
                var colorUsed = 'red';
                var signUsed = '';
            }
        }
        value = columnData['isPercent'] == 'true' ? '(' + signUsed + '' + value + ' %)' : ' (' + value + ')';
        if (color)
            return mainValue + ' <span style="color:' + colorUsed + '">' + value + '<span>';
        else
            return mainValue + value;
    }
    downloadHandle(e){
        e.preventDefault();
        this.drillFunction(jQuery('#download_property').val(), 'extract', jQuery('#download_pin').val())
    }
    render() {
        var that=this;
        setTimeout(function () { 
            dragcomplete();

            if(window.screen.width<=mobile_width){
                gridOptions.columnApi.setColumnPinned('label',null);

                gridOptions.columnApi.getAllColumns().forEach(function(column) {
                    gridOptions.columnApi.setColumnWidth(column.colId,120);
                });

            }else {
                // if(that.state.index==1)
                //     gridOptions.columnApi.autoSizeAllColumns(allColumnIds);
            }
        }, 1000);
        
        if (this.state.index)
            var id = 'myGridTop' + this.state.index;
        else var id = 'myGridTop';
        var tableHeight = this.state.dashboard=="insight" ? "400px" : (this.state.tableHeight ? this.state.tableHeight : '480px');
        var tableHeight = this.state.index==1 || this.state.dashboard=="insight"?{ minHeight: "150px", height: tableHeight, width: "100%"}:{ minHeight: "150px", maxHeight: tableHeight, width: "100%"}
        
        if (this.props.title){
            if (this.props.index) {
                var tableTitle = <div className="card-header pd-2"> {this.props.title} </div>
            }
            else{
            var tableTitle = <div className="card-header"> {this.props.title} </div>
            }
        }

        var class_card_name="card";
        var tableFooter = this.props.dashboard=='insight' ? null : <div className="card-footer">{this.props.final_details}</div>;
        
        if(this.props.index>1 && this.props.dashboard!='insight'){
            class_card_name = "";

            let displayValue = this.props.report_type && this.props.report_type == 'static' ? 'show' : 'none'
            // displayValue = this.props.dashboard_config && this.props.dashboard_config['information'] ? 'show' : 'none';

            let topMargin = window.innerWidth <= mobile_width ? "100%" : null
            tableFooter = <p className="card-footer pd-10 dashboard_footer_class slideInUp animated faster" id={"dashboard_footer_" + this.props.index} style={{ position: 'absolute', bottom: '0', maxHeight: '100px', backgroundColor: 'white', margin: '0px', width: "100%", display: displayValue, top: topMargin }}>{this.props.dashboard && this.props.dashboardDateInfo ? this.props.dashboardDateInfo : this.props.final_details}</p>
        }
        else {
            resetFilterGo();
            resetAppliedFilterFlag();
        }        
        resetFilterGo();
        resetAppliedFilterFlag();
        return (
            <span>
                <div className={class_card_name}>
                    {this.props.ExportComponentVar}
                    {tableTitle}
                    <div id={id} className={SKIN_MODE=="dark" ? "ag-theme-balham-dark" : "ag-theme-balham"} style={tableHeight}></div>
                    {tableFooter}
                </div>
                {/* <div className='tableDownloadComponent col-md-12'>
                    <TableDownload report={this.state.report} chartEnable={this.state.chartEnable} savedReportList={this.state.savedReportList} />
                </div> */}
            </span>
        );
    }
}

function clickEvent(e, type) {
    var callFunction = mainObj.drillHandle(e.innerHTML, type);
}

function ucwords (str) {
    return (str + '').replace(/^([a-z])|\s+([a-z])/g, function ($1) {
        return $1.toUpperCase();
    });
}

function smallFirstLetter(string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
}

function getIndexOfMetric(label, keyToUse='label') {
    var metricColumns = '';
    var index = -1   
    metricColumns = metricObjectGlobal.getColumn(keyToUse);
    index = metricColumns.indexOf(label);
    
    return index == -1 ? metricColumns.indexOf(label) : index;
}

// Function to extract values for keys matching the pattern 'labelN'
function extractLabelValues(obj) {
    return Object.keys(obj)
        .filter(key => /^label\d+$/.test(key))  // Filter keys matching the pattern 'labelN'
        .map(key => obj[key]);                  // Map the filtered keys to their values
}

export default TableComponent;